module.exports = __webpack_public_path__ + "img/green-title-th.1e9f9a1b.png";